import Service, { service } from '@ember/service';
import type AditoolsSiteService from '@ebiz/ember-aditools-site/services/aditools-site';
import type { SimDDSSiteConfigData } from 'simdds';
import { JsonProduct } from 'simdds/models/product';

export interface ToolData {
  status: number;
  toolName: string;
  settings: Record<string, string>;
  products: Array<JsonProduct>;
}
export default class CdpService extends Service {
  @service('aditools-site') declare siteconfig: AditoolsSiteService & SimDDSSiteConfigData;

  getToolData() {
    const configUrl = this.siteconfig.ConfigUrl + '?id=' + new Date().getTime();
    return fetch(configUrl).then((response) => {
      // Load tool data from config file
      if (response.status === 404) {
        throw new Error('Failed with Invalid status ' + response.statusText);
      } else {
        return response.json().then((data: ToolData) => {
          return data;
        });
      }
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    cdp: CdpService;
  }
}
